import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProductBox from "./ProductBox";
import Sidebar from "../Sidebar";
import { Breadcrumbs } from "./../Breadcrumb/index";

export default function ProductDetails() {
  return (
    <>
      {" "}
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }} className="pt-3">
            <Breadcrumbs currentPathName="Product Details" />
            <Row className="p-4">
              <Col className="rounded p-3">
                <Row>
                  <ProductBox />
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}
